import { useConfirmDrawer } from 'Store/confirm-drawer';
import { useTranslation } from 'react-i18next';

const useClockOutConfirmDrawer = () => {
  const { t } = useTranslation('host-attendance');
  const { onOpenConfirmDrawer } = useConfirmDrawer();

  const onClockOutConfirmDrawer = ({ onConfirm, onCancel }) => {
    onOpenConfirmDrawer({
      type: 'warning',
      title: t('clock_out_without_finishing.title'),
      description: t('clock_out_without_finishing.description'),
      confirmText: t('common:sure'),
      cancelText: t('common:back'),
      onConfirm,
      onCancel,
      confirmStyle: 'outline',
      cancelStyle: 'solid',
      switchOrder: true,
    });
  };

  return { onClockOutConfirmDrawer };
};

export default useClockOutConfirmDrawer;
